import React from 'react';
import axios from 'axios';
import HOC from './HOC';
import { Link } from 'react-router-dom';
import { FaSearch, FaArrowRight, FaBookOpen, FaClipboardList } from 'react-icons/fa';
import { Spinner } from 'react-bootstrap';
import apiUrl from './base_url';
import './cssfile/dashboard-refactored.css';

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: [],
            series: [],
            filteredSeries: [],
            isLoading: true,
            error: '',
            searchQuery: '',
        };
    }

    componentDidMount() {
        const email = localStorage.getItem('email');
        const password = localStorage.getItem('password');

        if (!email || !password) {
            this.props.history.push('/login');
            return;
        }

        axios
            .get(apiUrl + `serverside/userdata.php?email=${email}&password=${password}`)
            .then(response => {
                const user = Array.isArray(response.data) ? response.data : [];
                const regid = user[0]?.regid || '';

                this.setState({ user });
                localStorage.setItem('regid', regid);

                if (regid) {
                    this.getSeriesData(regid);
                } else {
                    this.setState({
                        isLoading: false,
                        error: 'Unable to identify your account.',
                    });
                }
            })
            .catch(error => {
                console.error('Unable to load user:', error);
                this.setState({
                    isLoading: false,
                    error: 'Unable to load your dashboard. Please try again.',
                });
            });
    }

    getSeriesData = regid => {
        axios
            .get(apiUrl + `serverside/seriesdata.php?regid=${regid}`)
            .then(response => {
                const series = Array.isArray(response.data) ? response.data : [];

                this.setState({
                    series,
                    filteredSeries: series,
                    isLoading: false,
                    error: '',
                });

                localStorage.setItem('series', JSON.stringify(series));
            })
            .catch(error => {
                console.error('Unable to load series:', error);
                this.setState({
                    isLoading: false,
                    error: 'Unable to load test series. Please try again.',
                });
            });
    };

    handleSearchChange = event => {
        const searchQuery = event.target.value;
        const query = searchQuery.trim().toLowerCase();

        const filteredSeries = this.state.series.filter(item =>
            String(item.topic_name || '').toLowerCase().includes(query)
        );

        this.setState({
            searchQuery,
            filteredSeries,
        });
    };

    renderSeriesCard = (item, index) => {
        const topicName = item.topic_name || 'Test Series';

        return (
            <article className="dashboard-series-card" key={item.a_id || item.id || index}>
                <div className="dashboard-series-image-wrap">
                    <img
                        src={item.image}
                        alt={topicName}
                        className="dashboard-series-image"
                    />
                    <div className="dashboard-series-image-overlay" />
                    <span className="dashboard-series-badge">
                        <FaBookOpen /> Test Series
                    </span>
                </div>

                <div className="dashboard-series-body">
                    <h3 title={topicName}>{topicName}</h3>

                    <div className="dashboard-series-meta">
                        <span>
                            <FaClipboardList /> Practice Tests
                        </span>
                    </div>

                    <Link
                        className="dashboard-series-button"
                        to={{
                            pathname: item.url,
                            state: {
                                a_id: item.a_id,
                                topic_name: topicName,
                            },
                        }}
                    >
                        <span>View Series</span>
                        <FaArrowRight />
                    </Link>
                </div>
            </article>
        );
    };

    render() {
        const {
            filteredSeries,
            isLoading,
            searchQuery,
            error,
            user,
            series,
        } = this.state;

        const candidateName =
            user[0]?.name ||
            user[0]?.username ||
            user[0]?.candidate_name ||
            'Candidate';

        return (
            <div className="dashboard-page">
                <div className="dashboard-shell">

                    <section className="dashboard-hero">
                        <div className="dashboard-hero-content">
                            <div>
                                <span className="dashboard-eyebrow">Candidate Dashboard</span>
                                <h1>Welcome, {candidateName}</h1>
                                <p>
                                    Choose a test series and continue your preparation.
                                </p>
                            </div>

                            <div className="dashboard-stat">
                                <strong>{series.length}</strong>
                                <span>Test Series</span>
                            </div>
                        </div>
                    </section>

                    <section className="dashboard-toolbar">
                        <div>
                            <h2>Available Test Series</h2>
                            <p>
                                {filteredSeries.length} of {series.length} series available
                            </p>
                        </div>

                        <div className="dashboard-search">
                            <FaSearch />
                            <input
                                type="text"
                                placeholder="Search test series..."
                                value={searchQuery}
                                onChange={this.handleSearchChange}
                                aria-label="Search test series"
                            />
                        </div>
                    </section>

                    {isLoading && (
                        <div className="dashboard-state">
                            <Spinner animation="border" />
                            <h3>Loading test series</h3>
                            <p>Please wait while we prepare your dashboard.</p>
                        </div>
                    )}

                    {!isLoading && error && (
                        <div className="dashboard-state dashboard-state-error">
                            <h3>Something went wrong</h3>
                            <p>{error}</p>
                            <button
                                type="button"
                                className="dashboard-retry-button"
                                onClick={() => window.location.reload()}
                            >
                                Try Again
                            </button>
                        </div>
                    )}

                    {!isLoading && !error && filteredSeries.length > 0 && (
                        <section className="dashboard-series-grid">
                            {filteredSeries.map(this.renderSeriesCard)}
                        </section>
                    )}

                    {!isLoading && !error && filteredSeries.length === 0 && (
                        <div className="dashboard-state">
                            <div className="dashboard-empty-icon">
                                <FaBookOpen />
                            </div>
                            <h3>
                                {searchQuery ? 'No matching series' : 'No test series available'}
                            </h3>
                            <p>
                                {searchQuery
                                    ? 'Try another search term.'
                                    : 'Add a test series to start preparing.'}
                            </p>

                            {searchQuery ? (
                                <button
                                    type="button"
                                    className="dashboard-retry-button"
                                    onClick={() =>
                                        this.setState({
                                            searchQuery: '',
                                            filteredSeries: this.state.series,
                                        })
                                    }
                                >
                                    Clear Search
                                </button>
                            ) : (
                                <Link to="/home" className="dashboard-retry-button">
                                    Add Series
                                </Link>
                            )}
                        </div>
                    )}

                </div>
            </div>
        );
    }
}

export default HOC(Dashboard);
